import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/pwaInstall"; // Side-effect: register beforeinstallprompt listener at startup.
import App from "@/App";

// Register PWA service worker.
// Kill-switch: visit `?clear-sw=1` to nuke caches + unregister the SW. Useful when a
// stale SW has cached a broken shell and the page renders blank.
if (typeof window !== 'undefined' && window.location.search.includes('clear-sw=1')) {
  Promise.all([
    'caches' in window ? caches.keys().then(keys => Promise.all(keys.map(k => caches.delete(k)))) : Promise.resolve(),
    'serviceWorker' in navigator
      ? navigator.serviceWorker.getRegistrations().then(regs => Promise.all(regs.map(r => r.unregister())))
      : Promise.resolve(),
  ])
    .catch(() => {})
    .finally(() => {
      // Strip the param and reload to a clean state
      const url = new URL(window.location.href);
      url.searchParams.delete('clear-sw');
      window.location.replace(url.toString());
    });
} else if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('SW registered:', reg.scope);
    }).catch((err) => {
      console.log('SW registration failed:', err);
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
